import React from "react";
import { Navigate } from "react-router-dom";
import { LoacalVariables } from "./commonFunctions/CommonFunctions";
import { getValue } from "./commonFunctions/CommonFunctions";

interface Props {
  children: React.ReactNode;
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<Props> = ({ children, allowedRoles }) => {
  const userType = getValue(LoacalVariables.UserType);

  // Role not allowed
  if (!allowedRoles.includes(userType)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;